var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrecciaSostenibilit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    stroke: "white",
    strokeWidth: 0.2,
    d: "M25.719 9.813l-8-8.5c-.373-.387-.979-.432-1.414-.04-.389.35-.399 1.034-.04 1.415L22.689 9.5H2c-.553 0-1 .447-1 1 0 .553.447 1 1 1h20.688l-6.422 6.813c-.36.38-.334 1.047.039 1.414.394.386 1.047.353 1.414-.04l8-8.5c.234-.23.277-.453.281-.687 0-.23-.14-.539-.281-.687z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrecciaSostenibilit);
export default __webpack_public_path__ + "static/media/freccia-sostenibilità.05facfb2f5d52dafef0dd1a5206798ad.svg";
export { ForwardRef as ReactComponent };